import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H1 } from 'components/common/Text/Text'
import { SPEAKABLE_SUMMARY } from 'constant'
import ArticlesAccordion from './components/ArticlesAccordion'
import Button from 'components/common/Button/Button'
import Icon from '../common/Icon/Icon'
import Image from 'components/common/Image'
import Theme from 'components/common/Theme/Theme'

// Article Landing Page
// url: '/resources'
const BOTArticleCategories = ({
  title,
  subtitle,
  onClick = () => {},
  moveToFeaturedArticle,
  showAccordionModal,
  articleCategory: {
    articleCategories = [],
    mostPopularAtricle
  } = {}
}) =>
  <Wrapper data-at-article-categories-wrapper>
    <Header>
      <TitleWrapper>
        <Title data-at-title headline headline_narrow centered>{ title }</Title>
        <Description data-at-description className={ SPEAKABLE_SUMMARY }>{ subtitle }</Description>
      </TitleWrapper>

      <AppointmentButton full="mobile" narrow onClick={ onClick }>
        <AppointmentIcon asset="book-appointment-white" />
        Request Appointment
        <ArrowIcon asset="arrow-right-white-secondary" />
      </AppointmentButton>
      <Media.Mobile>
        <ExploreTopicsButton onClick={ showAccordionModal }>
          Explore Topics
        </ExploreTopicsButton>
      </Media.Mobile>
    </Header>

    <ContentWrapper>
      <Media.Desktop>
        <AccordionWrapper>
          <ArticlesAccordion items={ articleCategories } />
        </AccordionWrapper>
      </Media.Desktop>

      <MainContentWrapper>
        <FeaturedArticleImage
          src={ mostPopularAtricle.articleImage }
          mobileSrc={ mostPopularAtricle.articleImage } />

        <FeaturedArticleSubtitle>
          {mostPopularAtricle.subtitle}
        </FeaturedArticleSubtitle>

        <FeaturedArticleTitle>
          {mostPopularAtricle.title}
        </FeaturedArticleTitle>

        <FeaturedArticleDescription>
          {mostPopularAtricle.description}
        </FeaturedArticleDescription>

        <LearnMoreButton narrow onClick={ moveToFeaturedArticle }>
          Learn More
          <LearnMoreArrowIcon asset="arrow-right-white-secondary" />
        </LearnMoreButton>

      </MainContentWrapper>
    </ContentWrapper>
  </Wrapper>

BOTArticleCategories.propTypes = {
  articleCategory: PropTypes.shape(),
  moveToFeaturedArticle: PropTypes.func,
  onClick: PropTypes.func,
  showAccordionModal: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string
}

export default BOTArticleCategories

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '75px auto 40px', '0 8px 40px')}
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 20px 0;
  ${Media.mobile`
    padding: 0 10px;
    flex-direction: column;
  `}
`

const TitleWrapper = styled.div`
  width: fit-content;
  ${Media.mobile`
    align-self: center;
    margin: 0 0 30px 0;
  `}
`

const AppointmentButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 20px 8px;
  margin: auto 0 7px 0;
  width: 335px;
  height: 46px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  ${Media.mobile`
    height: unset;
    width: unset;
    padding: 8px 20px 8px;
    margin: 0 0 30px 0;
  `}
`

const ExploreTopicsButton = styled(Button)`
  padding: 10px 30px 10px;
  margin: 0 0 20px 0;
  font-size: 16px;
  background-color: ${Theme.colors.white};
  color: ${Theme.colors.bright_red_new};
  border: 1px solid ${Theme.colors.bright_red_new};
  border-radius: 4px;
  cursor: pointer;
  line-height: 1.05em;
  letter-spacing: 0.05em;
  transform: scale(1, 1.3);
`

const AppointmentIcon = styled(Icon)`
  width: 30px;
  ${Media.mobile`
    width: 20px;
  `}
`

const ArrowIcon = styled(Icon)`
  width: 10px;
  ${Media.mobile`
    width: 7px;
  `}
`

const Title = styled(H1)`
  ${Mixin.font.GothamBold(34, 900)}
  ${Mixin.responsive('margin', '0 0 20px 0', '0 0 20px 0')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 900)}
    text-align: center;
  `}
  text-align: unset;
`

const Description = styled.p`
  text-align: center;
  ${Mixin.responsive('font-size', '18px', '16px')}
  ${Mixin.responsive('margin', '0', '0')}
`

const ContentWrapper = styled.div`
  display: flex;
`

const AccordionWrapper = styled.div`
  width: 250px;
`

const MainContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 425px;
  margin: 0 0 0 5px;
  padding: 88px 0 0 53px;
  background-image: linear-gradient(-90deg, rgba(242, 242, 242, 0) 0%, rgba(51, 51, 51, 0.6) 54.760000000000005%, rgba(0, 0, 0, 0.79) 100%);
  ${Media.mobile`
    padding: 49px 16px 0;
    height: 650px;
  `}
`

const FeaturedArticleImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  ${Media.mobile`
    object-fit: cover;
  `}
`

const FeaturedArticleSubtitle = styled.p`
  margin: 0 0 9px 0;
  font-size: 13px;
  color: ${Theme.colors.white};
  ${Media.mobile`
    padding: 0 16px 0;
  `}
`

const FeaturedArticleTitle = styled.p`
  margin: 0 0 20px 0;
  font-size: 36px;
  color: ${Theme.colors.white};
  ${Media.mobile`
    padding: 0 16px 0;
  `}
`

const FeaturedArticleDescription = styled.p`
  display: inline-block;
  width: 425px;
  margin: 0 0 50px 0;
  font-size: 18px;
  color: ${Theme.colors.white};
  ${Media.mobile`
    padding: 0 16px 0;
    width: auto;
  `}
`

const LearnMoreButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 340px;
  max-height: 50px;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
`

const LearnMoreArrowIcon = styled(Icon)`
  margin: 0 0 0 35px;
  width: 10px;
`
